export default __webpack_public_path__ + "static/media/scotia-bank-logo.a4ff3e3c.svg";